export default "__VITE_ASSET__BKAQybOO__"